import { useContext } from 'react';
import { LocalizationContext } from './LocalizationProvider';
export var useLocale = function useLocale() {
  var context = useContext(LocalizationContext);

  if (!context) {
    throw new Error('useLocale can only be used inside an LocalizationProvider with a value');
  }

  var locale = context.locale,
      setLocale = context.setLocale,
      loading = context.loading;
  return {
    locale: locale,
    setLocale: setLocale,
    loading: loading
  };
};